import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import dynamic from 'next/dynamic';
import { SlatePlugin } from '../../../../../../slatePlugins/slatePlugins.types';
import {
  ELEMENT_IMAGE_SLIDE_SHOW,
  ImageSlideShowPluginOptions,
} from './ImageSlideShowPlugin.types';

const ImageSlideShowControlEditElementReadOnly = dynamic<any>(() =>
  import('./components/ImageSlideShowControlEditElementReadOnly').then(
    (mod) => mod.ImageSlideShowControlEditElementReadOnly
  )
);
//
// const ImageSlideShowControlEditElementReadOnly = dynamicEditorComponent(
//   () =>
//     import(
//       /* webpackExports: "ImageSlideShowControlEditElementReadOnly" */ './components/ImageSlideShowControlEditElement'
//     ).then((mod) => mod.ImageSlideShowControlEditElementReadOnly),
//   {
//     ssr: true,
//   }
// );

export const ImageSlideShowReadOnlyPlugin = (
  options?: ImageSlideShowPluginOptions
): SlatePlugin => ({
  renderElement: (renderProps: RenderElementProps) => {
    const { element } = renderProps;
    if (element?.type === ELEMENT_IMAGE_SLIDE_SHOW) {
      return <ImageSlideShowControlEditElementReadOnly {...renderProps} {...options} />;
    }
    return undefined;
  },
  voidTypes: [ELEMENT_IMAGE_SLIDE_SHOW],
});
